import React, { useState } from 'react'
import { compose } from 'recompose'

import i18n from 'app/i18n'

import theme from 'app/theme'
import config from 'app/config'

import uuidV4 from 'uuid/v4'
import styled from 'styled-components'

import MuiGrow from '@material-ui/core/Grow'
import MuiPaper from '@material-ui/core/Paper'
import MuiPopper from '@material-ui/core/Popper'
import MuiMenuList from '@material-ui/core/MenuList'
import MuiIconTranslate from '@material-ui/icons/TranslateOutlined'
import MuiClickAwayListener from '@material-ui/core/ClickAwayListener'

import CsgButton from 'components/atoms/Button'
import CsgMenuItem from 'components/molecules/MenuItem'

import { withNamespaces } from 'react-i18next'

import Flags from 'country-flag-icons/react/3x2'

const LocaleTogglerButton = styled(CsgButton)`
  && {
    min-width: 32px;
    padding: 6px;
    box-shadow: none;
    text-transform: inherit;
    background-color: transparent;
    color: ${theme.palette.secondary.main};

    > span > svg {
      margin-left: 10px;
    }
  }
`

const LocaleToggler = ({ t, isAppBar }) => {
  const translateOptions = [
    {
      id: uuidV4(),
      code: 'pt-BR',
      flagCode: 'BR'
    },
    {
      id: uuidV4(),
      code: 'en-US',
      flagCode: 'US'
    },
    {
      id: uuidV4(),
      code: 'es-ES',
      flagCode: 'ES'
    }
  ]

  const [selectedCodeLanguage, setselectedCodeLanguage] = useState(i18n.language)
  const [anchorFab, setAnchorFab] = useState(null)
  const [popoverOpened, setPopoverOpened] = useState(false)

  const handlePopoverOpen = () => {
    setPopoverOpened(true)
  }

  const handlePopoverClose = () => {
    setPopoverOpened(false)
  }

  const changeLanguage = ({ code }) => {
    setselectedCodeLanguage(code)
    i18n.changeLanguage(code)
    handlePopoverClose()
  }

  return (
    <>
      {/* TODO: Variável de ambiente temporária, será removida após internacionalizão do backend #1007870 */}
      {config.project.hasToggleLocale && (
        <>
          <LocaleTogglerButton
            id="button-language"
            onClick={handlePopoverOpen}
            buttonRef={setAnchorFab}
            variant="contained"
            rel="noopener noreferrer"
            style={{
              position: isAppBar ? 'relative' : 'absolute',
              right: isAppBar ? 0 : 60,
              top: isAppBar ? 0 : 24
            }}
          >
            <MuiIconTranslate color="primary" />
          </LocaleTogglerButton>

          <MuiPopper open={popoverOpened} anchorEl={anchorFab} onClose={handlePopoverClose} transition disablePortal>
            {({ TransitionProps }) => (
              <MuiGrow {...TransitionProps}>
                <MuiPaper>
                  <MuiClickAwayListener onClickAway={handlePopoverClose}>
                    <MuiMenuList>
                      {translateOptions.map(lng => {
                        const Flag = Flags[lng.flagCode]
                        return (
                          <CsgMenuItem
                            key={lng.id}
                            active={lng.code === selectedCodeLanguage}
                            icon={<Flag style={{ width: '24px', height: '16px' }} />}
                            text={t(`locale_language_code_description.${lng.code}`)}
                            onClick={() => changeLanguage(lng)}
                          />
                        )
                      })}
                    </MuiMenuList>
                  </MuiClickAwayListener>
                </MuiPaper>
              </MuiGrow>
            )}
          </MuiPopper>
        </>
      )}
    </>
  )
}

export default compose(withNamespaces('translation'))(LocaleToggler)
